import type { ProductSort } from './products'

const queries = {
  // Meta
  user: () => ['user'],
  systemMessages: () => ['system-messages'],
  translationList: () => ['translation/list'],
  loginSettings: () => ['login-settings'],
  profile: () => ['profile'],
  stats: () => ['stats'],
  notifications: () => ['notifications'],
  managerToken: () => ['manager-token'],
  documentDownloadAuthorization: (documentId: number) => [
    'document',
    'download-authorization',
    documentId,
  ],

  injuryReports: () => ['injury-reports'],
  injuryReport: (id: number) => ['injury-reports', id],

  subscriptionOrderWaiver: (documentId: number) => ['subscription-order', 'waiver', documentId],
  demoCustomers: () => ['demo/customers'],
  demoTargets: () => ['demo/targets'],

  products: ({
    sorting,
    columnFilters,
    pagination,
  }: {
    sorting: ProductSort
    columnFilters: { keyword?: string; category?: string }
    pagination?: {
      page: number
      limit: number
    }
  }) => ['products', sorting, columnFilters, pagination],
  relatedProducts: ({
    sorting,
    columnFilters,
    pagination,
    productId,
    selectedFirst,
  }: {
    productId: number
    sorting: ProductSort
    columnFilters: { keyword?: string; category?: string[] }
    pagination?: {
      page: number
      limit: number
    }
    selectedFirst?: boolean
  }) => ['products', productId, 'related', sorting, columnFilters, pagination, selectedFirst],
  productsClassifications: () => ['products/classifications'],
}

export default queries
